import { computed, Ref } from "@vue/composition-api";
import { NumericRange } from "@web-components/types/NumericRange";

export interface RangeAttr {
  between: Readonly<Ref<boolean>>;
  betweenError: Readonly<Ref<boolean>>;
}

export const rangeValidator = (
  inputRef: Ref<string | number>,
  inputValueDirty: Ref<boolean>,
  range: NumericRange
): RangeAttr => {
  const between = computed(() => {
    let number = Number(inputRef.value);
    return number >= range.min && number <= range.max;
  });
  return {
    between,
    betweenError: computed(() => !between.value && inputValueDirty.value)
  };
};
